import { Outlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { useGallery, useOffers, useSettings, useVehicles } from "@/hooks/useSite";
import { EASE } from "@/components/motion/Reveal";

const Curtain = ({ ready }) => {
  const [minDone, setMinDone] = useState(() => !!sessionStorage.getItem("wcm_curtain"));
  useEffect(() => {
    if (minDone) return;
    sessionStorage.setItem("wcm_curtain", "1");
    const t = setTimeout(() => setMinDone(true), 1400);
    return () => clearTimeout(t);
  }, [minDone]);
  const show = !(ready && minDone);
  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="intro-curtain" className="fixed inset-0 z-[100] flex items-center justify-center bg-obsidian" exit={{ y: "-100%" }} transition={{ duration: 0.9, ease: EASE }}>
          <motion.p initial={{ opacity: 0, letterSpacing: "0.4em" }} animate={{ opacity: 1, letterSpacing: "-0.04em" }} transition={{ duration: 1, ease: EASE }} className="font-display text-5xl font-black uppercase text-white sm:text-7xl">
            JETOUR
          </motion.p>
          <motion.span initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1.1, delay: 0.2, ease: EASE }} className="absolute bottom-0 left-0 h-1 w-full origin-left bg-crimson" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const settled = (q) => q.isSuccess || q.isError;

export default function SiteLayout() {
  const settingsQ = useSettings();
  const vehiclesQ = useVehicles();
  const galleryQ = useGallery();
  const offersQ = useOffers();
  const ready = settled(settingsQ) && settled(vehiclesQ) && settled(galleryQ) && settled(offersQ);
  const settings = settingsQ.data || {};
  const vehicles = vehiclesQ.data || [];
  const gallery = galleryQ.data || [];
  const offers = offersQ.data || [];

  return (
    <SmoothScroll>
      <div className="grain relative min-h-screen bg-obsidian text-white">
        <Curtain ready={ready} />
        <Navbar showOffers={offers.length > 0} />
        {ready && (
          <>
            <main>
              <Outlet context={{ settings, vehicles, gallery, offers }} />
            </main>
            <Footer settings={settings} vehicles={vehicles} />
            <WhatsAppButton number={settings.whatsapp} />
          </>
        )}
      </div>
    </SmoothScroll>
  );
}
